/**
 * Alfabe bazlı sıra adı oluşturur (1-based)
 * 1→A, 2→B, 27→AA
 */
export const getAlphabetLabel = (rowNumber) => {
  let label = '';
  let current = rowNumber - 1;
  while (current >= 0) {
    label = String.fromCharCode(65 + (current % 26)) + label;
    current = Math.floor(current / 26) - 1;
  }
  return label;
};

/**
 * Koltuk ID üretir
 * seatStartNumber: o bölümün koltuk numaraları kaçtan başlıyor (varsayılan: 1)
 */
export const generateSeatId = (section, rowIndex, seatIndex, totalSeats) => {
  const rowNumber     = section.startRow + rowIndex;
  const seatStart     = section.seatStartNumber ?? 1;
  const seatsInRow    = totalSeats ?? section.seatsPerRow;
  // reverseSeats: sağdan sola — en yüksek numara solda
  const seatNumber    = section.reverseSeats
    ? seatStart + seatsInRow - 1 - seatIndex
    : seatStart + seatIndex;

  switch (section.namingMode || 0) {
    case 0: { // AlphabetContinuous
      const rowLabel = getAlphabetLabel(rowNumber);
      return `${rowLabel}${seatNumber}`;
    }
    case 1: // PrefixRowSeat
    case 2: // Manual
    default:
      return `${section.rowPrefix}${rowNumber}-${seatNumber}`;
  }
};

export const getRowLabel = (section, rowIndex) => {
  const rowNumber = section.startRow + rowIndex;
  switch (section.namingMode || 0) {
    case 0:  return getAlphabetLabel(rowNumber);
    case 1:  return `${section.rowPrefix} ${rowNumber}`;
    case 2:  return `${section.rowPrefix}${rowNumber}`;
    default: return getAlphabetLabel(rowNumber);
  }
};

export const previewSeatNames = (section) => {
  const rowCount    = section.endRow - section.startRow + 1;
  const seatStart   = section.seatStartNumber ?? 1;
  const seatEnd     = seatStart + (section.seatsPerRow - 1);
  const samples     = [];

  for (let i = 0; i < Math.min(3, rowCount); i++) {
    const rowLabel  = getRowLabel(section, i);
    const firstSeat = generateSeatId(section, i, 0);
    const lastSeat  = generateSeatId(section, i, section.seatsPerRow - 1);

    switch (section.namingMode || 0) {
      case 0:
        samples.push(`${rowLabel}: ${rowLabel}${seatStart}, ${rowLabel}${seatStart + 1}...${rowLabel}${seatEnd}`);
        break;
      case 1:
        samples.push(`Sıra ${section.startRow + i}: ${firstSeat}...${lastSeat}`);
        break;
      default:
        samples.push(`${rowLabel}: ${firstSeat}...${lastSeat}`);
    }
  }

  if (rowCount > 3) {
    samples.push('...');
    const lastIndex = rowCount - 1;
    const lastLabel = getRowLabel(section, lastIndex);
    const lastFirst = generateSeatId(section, lastIndex, 0);
    const lastLast  = generateSeatId(section, lastIndex, section.seatsPerRow - 1);
    samples.push(`${lastLabel}: ${lastFirst}...${lastLast}`);
  }

  return samples;
};